import Reflux from "reflux";
import Freezer from "freezer-js";
import RecommendationsActions from "../react_actions/recommendations_actions";
import ShelvingsActions from "../react_actions/shelvings_actions";

const state = new Freezer({});

const getState = function() {
  return state.get();
};

const store = Reflux.createStore({
  listenables: [RecommendationsActions,
                { bookShelved: ShelvingsActions.bookShelved }],

  getInitialState: getState,

  getState,

  initializeWith(data) {
    this.setRecommendations(data);
  },

  updateWith(data) {
    this.setRecommendations(data);
  },

  setRecommendations(data) {
    if (data.recommendations.length) {
      getState().reset(data)
        .set("activeRecommendationId", 0);
      this.notifyListeners();
    }
  },

  getActiveRecommendation() {
    return getState().recommendations[getState().activeRecommendationId];
  },

  onBookShelved(resp) {
    if (resp && resp.book && resp.book.bookId === this.getActiveRecommendation().book.bookId) {
      this.onRequestNextRec();
    }
  },

  onRequestNextRec() {
    const recommendations = getState().recommendations;
    const currentIndex = getState().activeRecommendationId;
    state.get().set("activeRecommendationId",
                    (currentIndex + 1) % recommendations.length);
    this.notifyListeners();
  },

  notifyListeners() {
    this.trigger(getState());
  },

  reset() {
    getState().reset({});
  },
});

export default store;
